<div class="confirmation-container"
  >
  @switch (displayMode) {
    @case ('RequiresDestinationInput') {
      <section>
        <div class="confirmation-status">
          <mat-icon class="confirmation-status-icon">check_circle</mat-icon>
          <div class="confirmation-status-title">{{'COMMAND.ORDER_PREPARATION.ORDER_CONFIRMATION.VALIDATED' | transloco}}</div>
        </div>
        <div class="confirmation-status-description">{{'COMMAND.ORDER_PREPARATION.ORDER_CONFIRMATION.INFO_REQUIRED' | transloco}}</div>
      </section>
    }
    @case ('WaitingForOtherOrders') {
      <section>
        <div class="confirmation-status">
          <mat-icon class="confirmation-status-icon">check_circle</mat-icon>
          <div class="confirmation-status-title">{{'COMMAND.ORDER_PREPARATION.ORDER_CONFIRMATION.VALIDATED' | transloco}}</div>
        </div>
        <div class="confirmation-status-description">{{'COMMAND.ORDER_PREPARATION.ORDER_CONFIRMATION.WAITING_OTHER_ORDERS' | transloco}}</div>
      </section>
    }
    @case ('OrderInPreparation') {
      <section>
        <div class="confirmation-status">
          <mat-icon class="confirmation-status-icon">check_circle</mat-icon>
          <div class="confirmation-status-title">{{'COMMAND.ORDER_PREPARATION.ORDER_CONFIRMATION.ORDER_PROCESSING' | transloco}}</div>
        </div>
      </section>
    }
    @case ('TableInPreparation') {
      <section>
        <div class="confirmation-status">
          <mat-icon class="confirmation-status-icon">check_circle</mat-icon>
          <div class="confirmation-status-title">{{'COMMAND.ORDER_PREPARATION.ORDER_CONFIRMATION.TABLE_PROCESSING' | transloco}}</div>
        </div>
      </section>
    }
    @default {
      <section>
        <app-page-loader></app-page-loader>
      </section>
    }
  }
</div>
